module.exports = __webpack_public_path__ + "assets/0d2042caeece48f7267a707f1e237947.svg";